module.exports = __webpack_public_path__ + "img/home_pic_up_3.988cc0d4.png";